import React, { useState, useEffect, useCallback } from 'react';
import axiosClient from '../../axios-client';
import { useNavigate } from 'react-router-dom';
import { AddIcon, SearchIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons'
import MyPagination from "../../components/MyPagination";
import { useStateContext } from "../../context/ContextProvider";
import { RiSecurePaymentFill } from "react-icons/ri";
import { ImInfo } from "react-icons/im";
import { IoMdClose } from "react-icons/io";

import {
    IconButton,
    Flex,
    Box,
    Heading,
    Button,
    Stack,
    Table,
    Thead,
    InputGroup,
    InputLeftElement,
    Tbody,
    Tr,
    Th,
    Select,
    Avatar,
    Switch,
    Badge,
    Td,
    Input,
    useToast,
    TableContainer,
    useColorModeValue,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Tooltip,
    Text,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Modal,
    Alert,
    ModalFooter,
    ModalOverlay,
    AlertIcon,
    useDisclosure,
    FormControl,
    FormLabel,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverHeader,
    PopoverCloseButton,
    PopoverBody,
    PopoverFooter,
    Card,
    CardHeader,
    Menu,
    MenuList,
    MenuButton,
    MenuItem,
    SimpleGrid,
    Image,
    SkeletonCircle,
    Skeleton,
    FocusLock,
    ButtonGroup,
    Divider,
    Grid,
    InputLeftAddon,
    Checkbox,

} from '@chakra-ui/react';
import { MdGroupRemove } from 'react-icons/md';
import { PiPlus, PiPlusBold } from 'react-icons/pi';
import { useTranslation } from 'react-i18next';
import { BiLeftArrowAlt, BiPlusCircle, BiSolidLeftArrowAlt } from 'react-icons/bi';
import { BsFillInfoCircleFill, BsInfoCircle, BsThreeDotsVertical } from 'react-icons/bs';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { TbReload } from "react-icons/tb";


export const GestClients = () => {
    const [loadingData, setLoadingData] = useState(true)
    const [checkLengthData, setCheckLengthData] = useState(false)
    const [selectedAbonnement, setSelectedAbonnement] = useState(null);

    const toast = useToast()
    const [selectedEtat, setSelectedEtat] = useState(null);
    const [selectedSubscriptionType, setSelectedSubscriptionType] = useState("");
    const [selectedPaymentStatut, setSelectedPaymentStatut] = useState("");
    const [selectedSubscriptionStatut, setSelectedSubscriptionStatut] = useState("");
    const [promoCode, setPromoCode] = useState("");
    const [listTypeAbonnements, setListTypeAbonnements] = useState([]);
    const [abonnements, setAbonnements] = useState([]);
    const { t } = useTranslation();
    const [email, setEmail] = useState()
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [isChangeStripeCIdOpen, setIsChangeStripeCIdOpen] = useState(false);

    const [isAddFormOpen, setIsAddFormOpen] = useState(false);
    const [isEditFormOpen, setIsEditFormOpen] = useState(false);
    //search variable
    const [searchTerm, setSearchTerm] = useState('');
    const [changeModal, setChangeModal] = useState(true)

    const [selectedUsedId, setSelectedUsedId] = useState(null)
    const [lastLoginChecked, setLastLoginChecked] = useState(false);

    const navigate = useNavigate()

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isEmailOpen, setIsEmailOpen] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [typeAb, setTypeAb] = useState();
    const [typeAbFilter, setTypeAbFilter] = useState("");

    const [typeFee, setTypeFee] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [stripeCId, setStripeCId] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [clientData, setClientData] = useState();
    const [clientAb, setClientAb] = useState();

    const [count, setCount] = useState(null);

    const initRef = React.useRef()
    const [currentPage, setCurrentPage] = useState(0);
    const [paginationData, setPaginationData] = useState()
    const [indexDisplayEmail, setIndexDispalyEmail] = useState(-1)
    const [addingCodeProgress, setAddingCodeProgress] = useState(false)

    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const onOpenPreview = () => {
        setIsPreviewOpen(true);
    };
    const onClosePreview = () => {
        setIsPreviewOpen(false);
    };

    const onOpenStripeCIdModal = () => {
        setIsChangeStripeCIdOpen(true);
    };
    const onCloseStripeCIdModal = () => {
        setIsChangeStripeCIdOpen(false);
    };
    // const { onOpen, onClose, isOpen } = useDisclosure()
    const firstFieldRef = React.useRef(null)

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };

    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };

    const onOpenEmail = () => {
        setIsEmailOpen(true);
    };

    const onCloseEmail = () => {
        setIsEmailOpen(false);
        setIndexDispalyEmail(-1)
        setMessageE('')
        setEmail()
    };

    const MAX_WORDS = 2; // Maximum number of words to display

    function truncateAddress(address) {
        const words = address.split(' ');
        if (words.length > MAX_WORDS) {
            return words.slice(0, MAX_WORDS).join(' ') + '...';
        }
        return address;
    }
    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////

    // current user
    const { user, setUser } = useStateContext();

    const [deleteId, setDeleteId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [selectedClient, setSelectedClient] = useState();
    const cancelRef = React.useRef()

    //Client data
    const [data, setData] = useState([]);

    // current user data
    // useEffect(() => {
    //     axiosClient.get('auth/user/')
    //         .then(({ data }) => {
    //             setUser(data)
    //         })
    // }, [])

    //get the clients data
    useEffect(() => {
        // setLoadingData(true)

        axiosClient.get(`/clients/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&abonnement=${""}&paymentStatut=${selectedPaymentStatut}&subscriptionStatus=${selectedSubscriptionStatut}&subscriptionType=${selectedSubscriptionType}&start_date=${startDateFilter ? startDateFilter : ""}&end_date=${endDateFilter ? endDateFilter : ""}&last_login=${lastLoginChecked}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);
                setCount(response.data.count || 0)
                // if (selectedEtat !== null) {
                //     filteredData = filteredData.filter((item) => item.etat === selectedEtat);
                // }
                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });
        axiosClient.get(`/subscriptions/`)
            .then((response) => {
                setAbonnements(response.data);
                // if (selectedEtat !== null) {
                //     filteredData = filteredData.filter((item) => item.etat === selectedEtat);
                // }

                // setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                // setLoadingData(false)

            });

    }, [typeAb, selectedEtat, pageSize, currentPage, searchTerm, typeAbFilter, selectedPaymentStatut, selectedSubscriptionStatut, selectedSubscriptionType, startDateFilter, endDateFilter,lastLoginChecked]);

    function update() {
        axiosClient.get(`/clients/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&etat=${selectedEtat}&abonnement=${""}&paymentStatut=${selectedPaymentStatut}&subscriptionStatus=${selectedSubscriptionStatut}&subscriptionType=${selectedSubscriptionType}&start_date=${startDateFilter ? startDateFilter : ""}&end_date=${endDateFilter ? endDateFilter : ""}&last_login=${lastLoginChecked}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);
                // if (selectedEtat !== null) {
                //     filteredData = filteredData.filter((item) => item.etat === selectedEtat);
                // }
                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });
    }
    const [message, setMessage] = useState(false)

    // delete client
    const handleDelete = (id = deleteId) => {
        if (!id) return;
        axiosClient.delete(`/clients/delete/${id}/`)
            .then((response) => {
                setData((prevData) => prevData.filter((row) => row.id !== id));
                toast({
                    description: t("l'utilisateur est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    const handleEtatClick = (id, etat) => {
        const formData = new FormData();
        formData.append("etat", !etat);

        axiosClient.put(`/update_client_etat/${id}/`, formData)
            .then((response) => {
                setData(rows => rows.map(row => {
                    if (row.id === id) {
                        return {
                            ...row,
                            etat: !etat,
                        };
                    }
                    return row;
                }));
            })
            .catch((error) => {
                // console.error(error)
            });
        if (!etat) {
            toast({
                description: t("le compte est activé"),
                status: 'success',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            })
        }
        else {
            toast({
                description: t("le compte est désactivé"),
                status: 'warning',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
            })
        }
    }
    // const handleStripeCustomerIdChange = (id) => {
    //     const formData = new FormData();
    //     setAddingCodeProgress(true)
    //     formData.append("stripe_customer_id", stripeCId);

    //     axiosClient.put(`/update_client_stripe_customer_id/${id}/`, formData)
    //         .then((response) => {
    //             toast({
    //                 description: t("L'identifiant client Stripe a été mis à jour avec succès"),
    //                 status: 'success',
    //                 variant: 'left-accent',
    //                 duration: 2000,
    //                 isClosable: true,
    //                 position: 'bottom-right'
    //             })
    //             setStripeCId("")
    //             onCloseStripeCIdModal()
    //             update()
    //             setAddingCodeProgress(false)
    //         })
    //         .catch((error) => {
    //             setAddingCodeProgress(false)
    //             // console.error(error)
    //         });

    // }

    const [messageE, setMessageE] = useState('');
    const emailRegex = /^[a-zA-Z][a-zA-Z0-9._-]*@[a-zA-Z]+(?:-[a-zA-Z]+)?\.[a-zA-Z]{2,}$/;

    const EditEmail = async (id) => {


        const formData = new FormData();
        if (email) { formData.append("email", email); }

        // const newList = listAdmins.filter((e) => e.id !== user.id);
        // if (newList.length > 0) {
        //     const check = newList.find((obj) => {
        //         return obj.email === email.trim();
        //     });
        //     if (check) {
        //         window.scrollTo(0, 0);
        //         return setMessageE(t("Ce mail existe déjà !"));
        //     }
        // }
        if (email && !emailRegex.test(email)) {
            return setMessageE(t("Veuillez entrer un email valide."));
        }
        if (!email) {
            onCloseEmail()
            return
        }

        try {
            const response = await axiosClient.put(`/update_user_email/${id}/`, formData)

            if (response.data.message) {
                setData(data.map((val, key) => {
                    if (val.id === id) {
                        return {
                            ...val,
                            email: email
                        }
                    }
                    return val
                }))
                toast({
                    description: t("L'email d'utilisateur est modifiée avec succèss"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'

                });
                onCloseEmail()
                // setTimeout(() => {
                //     window.location.reload();
                // }, 2000);
            }
            else {
                setMessageE(t("Ce mail existe déjà"))
            }
        } catch (err) {
            toast({
                description: "erreur",
                status: 'warning',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'
            })
        }
    }
    const handleSubmit = async (type, subId, price) => {

        // Create FormData instance
        const formData = new FormData();
        formData.append('amount', price);
        formData.append('user', selectedUsedId);
        formData.append('subscriptionType', type);
        formData.append('promoCode', promoCode);
        formData.append('start_date', startDate);
        formData.append('end_date', endDate);
        formData.append('subscription', subId);

        try {
            // Send FormData to backend
            axiosClient.post('/create-payment-admin', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((response) => {
                    toast({
                        description: 'Abonnement ajouté avec succès.',
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                        position: "bottom-right",
                        variant: "left-accent",
                    });
                    setIsPreviewOpen(false);
                    update()
                })
                .catch((err) => {
                    const response = err.response;
                    // console.error(response);
                });
        } catch (error) {
            // console.error('Error during payment process:', error);
        }
    };
    const [loading, setLoading] = useState(false);

    const handleRetryPayment = async (id) => {
        setLoading(true);
        setMessage("");

        try {
            const response = await axiosClient.post("retry-failed-payment/", { user_id: id });
            //   setMessage(response.data.message || "Payment retry successful!");
            toast({
                description: response.data.message || t("Nouvelle tentative de paiement réussie !"),
                status: 'success',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'

            });
        } catch (error) {
            console.log(error.response?.data?.error);

            toast({
                description: "Une erreur s'est produite.",
                status: 'warning',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'
            })
            //   setMessage(error.response?.data?.error || "Failed to retry payment.");
        }

        setLoading(false);
    };

    function reset() {
        setSelectedEtat("")
        setSelectedPaymentStatut("")
        setSelectedSubscriptionStatut("")
        setSelectedSubscriptionType("")
        setStartDateFilter('')
        setEndDateFilter('')
        setSearchTerm('')
    }

    const cardColor = useColorModeValue('linear-gradient(90deg, rgba(221,230,239,1) 0%, rgba(255,255,255,1) 100%)', 'linear-gradient(90deg, rgba(75,87,104,1) 0%, rgba(45,55,72,1) 100%)')
    return (
        <Box mt="5px" >
            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t('Accueil')}</span>  / <span >Clients</span></Text>
                    <Button onClick={() => navigate('/ajouter-client')} leftIcon={<AiOutlineUserAdd />} color={"white"} bgGradient='linear(to-r, #eb6921, #fa8d51)' _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} variant='solid'>
                        {t("Ajouter client")}
                    </Button>
                </Box>
            </Flex>

            <Flex
                align={'center'}
                justify={'center'}
            >
                <Stack
                    w={'full'}
                    maxW='full'
                    bg={useColorModeValue('white', 'gray.700')}
                    rounded={'lg'}
                    p={6}
                    my={5}>
                    {/* Search input */}
                    <Flex
                        mb={6}
                        gap={4}
                        // justifyContent="space-around"
                        alignItems="center"
                        direction={{ base: 'column' }}
                    >
                        <Flex
                            direction={{ base: 'column', xl: 'row' }}
                            w="100%"
                            alignItems="end"
                            gap={2}
                        >
                            <Flex
                                direction="row"
                                alignItems="center"
                                flexWrap="wrap" // ← allow wrapping if needed
                                gap={2}
                                w={{ base: '100%', xl: '50%' }}
                            >
                                <Text whiteSpace="nowrap" fontWeight="medium">
                                    Clients inscrit
                                </Text>

                                <InputGroup size="sm" flex="1" minW="0">
                                    <InputLeftAddon children={t('De :')} />
                                    <Input
                                        type="date"
                                        borderColor="gray.300"
                                        borderRadius="5"
                                        placeholder="Start Date"
                                        value={startDateFilter}
                                        onChange={(e) => setStartDateFilter(e.target.value)}
                                        minW="120px" // ← avoid being too small
                                    />
                                </InputGroup>

                                <InputGroup size="sm" flex="1" minW="0">
                                    <InputLeftAddon children={t('À :')} />
                                    <Input
                                        type="date"
                                        borderColor="gray.300"
                                        borderRadius="5"
                                        placeholder="End Date"
                                        value={endDateFilter}
                                        onChange={(e) => setEndDateFilter(e.target.value)}
                                        minW="120px"
                                    />
                                </InputGroup>
                            </Flex>

                            <Flex
                                w={{ base: '100%', xl: '50%' }}
                                gap={2}
                                justify="center"
                                align="center"
                                flexWrap="wrap" // ← allow wrapping
                            >
                                <InputGroup size="sm" flex="1" minW="0">
                                    <InputLeftElement
                                        pointerEvents="none"
                                        children={<SearchIcon color="gray.300" />}
                                    />
                                    <Input
                                        borderRadius="5"
                                        placeholder={t('Recherche...')}
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setCurrentPage(0);
                                            setSearchTerm(e.target.value);
                                        }}
                                        minW="120px"
                                    />
                                </InputGroup>
                                <Checkbox
                                colorScheme='cyan'
                                isChecked={lastLoginChecked}
                                onChange={(e) => {
                                    setLastLoginChecked(e.target.checked)
                                }}
                                
                                >dernière connexion</Checkbox>
                                {(searchTerm
                                    || endDateFilter
                                    || startDateFilter
                                    || selectedSubscriptionStatut
                                    || selectedPaymentStatut
                                    || (selectedEtat !== null && selectedEtat !== "")
                                    || selectedSubscriptionType
                                )
                                    &&
                                    <IconButton
                                        size="sm"
                                        onClick={reset}
                                        title="réinitialiser les filtres"
                                        colorScheme="red"
                                        variant="outline"
                                        icon={<IoMdClose size="20px" />}
                                    />
                                }


                                
                            </Flex>
                        </Flex>


                        <Grid
                            templateColumns={{ base: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }}
                            gap={2}
                            w="100%"

                        >
                            <Select borderRadius="5" size="sm" fontSize={{ base: 13, lg: 16 }} w={"100%"} value={selectedSubscriptionStatut}
                                onChange={(e) => {
                                    setCurrentPage(0)
                                    setSelectedSubscriptionStatut(e.target.value)
                                }}>

                                <option value=''>{t("Abonnement")}</option>
                                <option value='true'>{t("Abonné")}</option>
                                <option value='false'>{t("Non abonné")}</option>
                            </Select>
                            <Select borderRadius="5" size="sm" fontSize={{ base: 13, lg: 16 }} w={"100%"} value={selectedPaymentStatut} onChange={(e) => {
                                setCurrentPage(0)
                                setSelectedPaymentStatut(e.target.value)
                            }
                            }>
                                <option value=''>{t("Paiment")}</option>
                                <option value='true'>{t("Payé")}</option>
                                <option value='false'>{t("Non payé")}</option>
                            </Select>
                            <Select borderRadius="5" size="sm" fontSize={{ base: 13, lg: 16 }} w={"100%"} value={selectedEtat}
                                onChange={(e) => {
                                    setCurrentPage(0)
                                    setSelectedEtat(e.target.value === '' ? null : e.target.value === 'true')
                                }}>
                                <option value="">{t("Tout")}</option>
                                <option value="true">{t("Activé")}</option>
                                <option value="false">{t("Désactivé")}</option>
                            </Select>
                            <Select borderRadius="5" size="sm" fontSize={{ base: 13, lg: 16 }} w={"100%"} value={selectedSubscriptionType}
                                onChange={(e) => {
                                    setCurrentPage(0)
                                    setSelectedSubscriptionType(e.target.value)
                                }}>
                                <option value="">{t("Type d'abonnement")}</option>
                                {abonnements.map((ab, key) => (
                                    <option value={ab.id}>{ab?.name}</option>
                                ))}
                                {/* <option value="ANNUEL">{t("Annuel")}</option>
                                <option value="MENSUEL">{t("Mensuel")}</option>
                                <option value="TRIAL">{t("Period d'essaie")}</option> */}
                            </Select>

                        </Grid>
                        <Flex w={"100%"} justify={"end"}>
                            <Badge
                                alignItems="center"
                                display="flex"
                                gap={2}
                                py={0.5}
                                px={3}
                                rounded="xl"
                                fontSize={"11px"}
                                colorScheme="purple"
                            >
                                Total clients : <Text fontSize="sm">{count}</Text>
                            </Badge>
                        </Flex>

                    </Flex>
                    <TableContainer>
                        <Table size="sm" >
                            <Thead size="sm">
                                <Tr fontSize="12">
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12">Code</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("Nom")}</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("Prénom")}</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12"> Email</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12"> Statut d'abonnement</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12"> Statut de paiement</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12"> Type d'abonnement</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12"> Date d'abonnement</Th>
                                    {/* <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("Pays")}</Th> */}
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("État")}</Th>

                                    <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("Date Création")}</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("dernière connexion")}</Th>
                                    {(user.role === "SUPERADMIN") &&
                                        <Th fontFamily='Plus Jakarta Display' fontSize="12">Options</Th>
                                    }
                                </Tr>
                            </Thead>
                            <Tbody>
                                {loadingData &&
                                    <Tr>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>

                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                        <Td> <Skeleton height='20px' /></Td>
                                    </Tr>}

                                {(paginationData?.length !== 0) &&
                                    data.map((row, key) => (<Tr key={row.id}>
                                        <Td >{row.code}</Td>
                                        <Td>{row.last_name}</Td>
                                        <Td>{row.first_name}</Td>
                                        <Td >{row.email}

                                            {/* <Popover
                                                isOpen={isEmailOpen}
                                                initialFocusRef={firstFieldRef}
                                                onOpen={onOpenEmail}
                                                onClose={onCloseEmail}
                                                placement='bottom'
                                                closeOnBlur={false}
                                            >
                                                <PopoverTrigger >
                                                    <IconButton variant={'ghost'} onClick={() => setIndexDispalyEmail(key)} size='sm' icon={<EditIcon />} />
                                                </PopoverTrigger>
                                                {indexDisplayEmail === key &&
                                                    <PopoverContent p={5}>
                                                        <FocusLock returnFocus persistentFocus={false}>
                                                            <PopoverArrow />
                                                            <PopoverCloseButton />
                                                            <Stack pt={3} spacing={4}>
                                                                {messageE &&
                                                                    <Alert fontSize={"sm"} padding={2} status='error' rounded="md" variant='left-accent'>
                                                                        <AlertIcon />
                                                                        {messageE}
                                                                    </Alert>}
                                                                <Input maxLength={50} border={"1px solid lightgray"} defaultValue={email ? email : row.email} onChange={(e) => setEmail(e.target.value)} />

                                                                <ButtonGroup display='flex' justifyContent='flex-end'>
                                                                    <Button size={"sm"} colorScheme='red' variant='outline' onClick={onCloseEmail}>
                                                                        {t("Annuler")}
                                                                    </Button>
                                                                    <Button onClick={() => EditEmail(row.id)} size={"sm"} colorScheme='teal'>
                                                                        {t("Enregistrer")}
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </Stack>
                                                        </FocusLock>
                                                    </PopoverContent>}
                                            </Popover> */}

                                        </Td>
                                        <Td>
                                            {(row.stripe_customer_id && row.is_subscribed) ? (
                                                <Flex gap={2}>
                                                    <Badge alignItems={"center"} display={'flex'} gap={3} px={2} py={0.5} rounded={"lg"} colorScheme="blue">

                                                        Abonné
                                                    </Badge>


                                                </Flex>

                                            ) : (
                                                <Flex gap={2}>
                                                    <Badge alignItems={"center"} display={'flex'} gap={3} px={2} py={0.5} rounded={"lg"} colorScheme="red">

                                                        Non Abonné
                                                    </Badge>


                                                </Flex>
                                            )}
                                        </Td>

                                        <Td>

                                            {row.has_active_subscription ? (
                                                <Flex gap={2}>
                                                    <Badge alignItems={"center"} display={'flex'} gap={3} px={2} py={0.5} rounded={"lg"} colorScheme="green">

                                                        Payé
                                                    </Badge>


                                                </Flex>

                                            )

                                                : (
                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <Badge alignItems={"center"} display={'flex'} gap={3} px={2} py={0.5} rounded={"lg"} colorScheme="orange">

                                                            Non payé
                                                            {(row.stripe_customer_id && row.is_subscribed) &&
                                                                <BiPlusCircle
                                                                    onClick={() => {
                                                                        onOpenPreview();
                                                                        // setSubscription(row);
                                                                        setSelectedUsedId(row.id)
                                                                    }}
                                                                    cursor={"pointer"} size={18} />

                                                            }

                                                        </Badge>
                                                        {(row.stripe_customer_id && row.is_subscribed) &&
                                                            <IconButton
                                                                size={"xs"} rounded={"full"} onClick={() => handleRetryPayment(row.id)}
                                                                colorScheme='blue'
                                                                aria-label='Search database'
                                                                icon={<TbReload />}
                                                            />}

                                                    </div>
                                                )
                                            }

                                        </Td>
                                        <Td>
                                            {row?.last_active_payment?.subscription_type
                                                ? row?.last_active_payment?.subscription_type
                                                    .toLowerCase()
                                                    .replace(/^\w/, (c) => c.toUpperCase())
                                                : "----"}
                                        </Td>
                                        <Td>{row?.last_active_payment?.creation_date ? new Date(row?.last_active_payment?.creation_date).toLocaleDateString(t("fr-FR")) : "----"}</Td>

                                        {/* <Td>{row.pays}</Td> */}
                                        <Td>
                                            <Flex>
                                                <Stack direction='row' mr="3px">
                                                    {(user.role === "SUPERADMIN" || user.role === "ADMIN") &&
                                                        <Switch
                                                            colorScheme='green'
                                                            isChecked={row.etat}
                                                            onChange={() => handleEtatClick(row.id, row.etat)}
                                                        />
                                                    }
                                                </Stack>
                                                <Badge
                                                    size="sm"
                                                    rounded={'lg'}
                                                    colorScheme={!row.etat ? 'red' : 'green'}
                                                >
                                                    {row.etat ? t("Activé") : t("Désactivé")}
                                                </Badge>
                                            </Flex>
                                        </Td>


                                        <Td>{new Date(row.creation_date).toLocaleDateString(t("fr-FR"))}</Td>
                                        <Td>{row.last_login ? new Date(row.last_login).toLocaleString(t("fr-FR")) : <Text color={"gray.400"}>Non défini</Text>}</Td>
                                        <Td>

                                            {/* <IconButton
                                                size="sm"
                                                onClick={() => navigate(`/editResponsable`, {
                                                    state: {
                                                        idResponsable: row.id
                                                    }
                                                })}
                                                mr="5px"
                                                colorScheme="green"
                                                icon={<EditIcon />}>
                                            </IconButton> */}
                                            {/* <Popover placement="left" >
                                                <PopoverTrigger>
                                                    <IconButton
                                                        size="sm"
                                                        mr="5px"
                                                        bg="gray.300"
                                                        color={"black"}
                                                        icon={<MdHistory />}>
                                                    </IconButton>
                                                </PopoverTrigger>
                                                <PopoverContent w={"full"} color="black" bgGradient='linear(to-r, white, #497dff)' >
                                                    <PopoverHeader letterSpacing={1.5} pt={4} fontWeight="bold" border="0">
                                                        Historique
                                                    </PopoverHeader>
                                                    <PopoverArrow bg="#497dff" />
                                                    <PopoverCloseButton />
                                                    <PopoverBody>
                                                        <div style={{ marginBottom: '8px' }}>
                                                            Ajouté par : {row.added_by}
                                                        </div>
                                                        <div style={{ marginBottom: '8px' }}>
                                                            Modifié par : {row.edited_by}
                                                        </div>

                                                        <div>
                                                            Date de dernière modification: {new Date(row.date_modification).toLocaleString('fr-FR')}
                                                        </div>
                                                    </PopoverBody>
                                                    <PopoverHeader pt={4} fontWeight="bold" border="0">
                                                    </PopoverHeader>
                                                </PopoverContent>
                                            </Popover> */}
                                            {(user.role === "SUPERADMIN") &&

                                                <IconButton
                                                    size="sm"
                                                    onClick={() => {
                                                        setDeleteId(row.id);
                                                        onOpenAlert();

                                                    }}
                                                    mr="5px"
                                                    colorScheme="red"
                                                    icon={<MdGroupRemove />}>
                                                </IconButton>}

                                            {/* <IconButton
                                                size="sm"
                                                onClick={() => {
                                                    setUserId(row.id);
                                                    setSelectedClient(row);
                                                    onOpenStripeCIdModal();

                                                }}
                                                mr="5px"
                                                colorScheme="blue"
                                                icon={<RiSecurePaymentFill size={"18px"} />}>
                                            </IconButton> */}
                                        </Td>

                                    </Tr>
                                    ))}
                                {(((searchTerm || selectedEtat !== null || selectedPaymentStatut !== "" || selectedSubscriptionStatut !== "" || selectedSubscriptionType !== "" || startDateFilter !== null || endDateFilter !== null) && paginationData?.length === 0) || (checkLengthData)) && (
                                    <Tr>
                                        <Td colSpan={11}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                                    </Tr>
                                )}
                            </Tbody>
                        </Table>

                    </TableContainer>
                    {/* Pagination */}
                    <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                        <Box flex="1">
                            <MyPagination
                                paginationData={paginationData}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                PAGE_SIZE={pageSize}
                            />
                        </Box>

                        <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                            {/* Add more options as needed */}
                        </Select>
                    </Flex>
                </Stack>
            </Flex>
            <AlertDialog
                closeOnOverlayClick={false}
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Supprimer')}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            <Text>
                                {t('êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.')}
                            </Text>
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button size={"sm"} ref={cancelRef} onClick={() => {
                                setMessage(false)
                                onCloseAlert()
                            }}>
                                {t('Annuler')}
                            </Button>
                            <Button size={"sm"} onClick={() => handleDelete(deleteId)} colorScheme='red' ml={3} isDisabled={message}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            <Modal
                size={"full"}
                isOpen={isPreviewOpen}
                onClose={() => {
                    onClosePreview();
                }}
            >
                <ModalOverlay />
                <ModalContent
                    w="auto"
                    // maxW="400px"
                    bg="transparent"
                    boxShadow="none"
                    display="flex"
                    flexDir={{ base: "column", md: "row" }}
                    gap={5}
                    justifyContent="center"
                    alignItems="center"
                >
                    {abonnements.map((ab, key) => (
                        <Box
                            key={1}
                            minW={"350px"}
                            p="6"
                            bg="white"
                            textAlign="center"
                            rounded="2xl"
                            shadow="xl"
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            overflowY="auto" // Scroll if content exceeds max height
                            height="100%" // Ensure the Box stretches to the full height of its container
                        >
                            <Box>
                                <Box>
                                    <Heading size="lg" mb="2" color="black" fontWeight="semibold">
                                        {ab?.name}
                                    </Heading>
                                    <Text>{ab?.description}</Text>
                                    <Text pt="2" letterSpacing="wide">
                                        <Text as="span" color="orange.400" verticalAlign="top">
                                            €{" "}
                                        </Text>
                                        <Text as="span" fontSize="2xl" fontWeight="semibold" color="orange.400">
                                            {ab?.price}
                                        </Text>
                                        <Text as="span" fontWeight="medium" color="orange.400">
                                            {" "}
                                            / {ab?.type === "ANNUEL" ? "Année" : "Mois"}
                                        </Text>
                                    </Text>
                                </Box>

                                <Divider mt="4" borderColor="gray.300" />
                                <Flex justify={"center"} pt="5" flexDirection="column" align="center">
                                    {ab?.features?.map((feature, index) => (
                                        <Text
                                            textAlign="center"
                                            key={index}
                                            fontSize="md"
                                            fontWeight="semibold"
                                            color="black"
                                            pt="4"
                                        >
                                            {feature}
                                        </Text>
                                    ))}
                                </Flex>
                            </Box>
                            <Flex flexDirection="column" mt="8" gap="3" flexGrow={1}>
                                {/* <Input
                                    onChange={(e) => setPromoCode(e.target.value)}
                                    type="text"
                                    placeholder="Code promo"
                                    bg="gray.50"
                                    rounded="lg"
                                    size="md"
                                    border="1px solid"
                                    borderColor="gray.300"
                                    focusBorderColor="gray.100"
                                    _placeholder={{ color: "gray" }}
                                /> */}
                                <Flex flexDir={"column"} gap={2}>
                                    <Flex >
                                        {/* <Text width={""}> Date de début :</Text> */}
                                        <Input
                                            onChange={(e) => setStartDate(e.target.value)}
                                            type="datetime-local"
                                            placeholder="start date"
                                            bg="gray.50"
                                            rounded="lg"
                                            size="md"
                                            border="1px solid"
                                            borderColor="gray.300"
                                            focusBorderColor="gray.100"
                                            _placeholder={{ color: "gray" }}
                                        />
                                    </Flex>
                                    <Flex>
                                        {/* <Text width={""}> Date de début :</Text> */}
                                        <Input
                                            onChange={(e) => setEndDate(e.target.value)}
                                            type="datetime-local"
                                            placeholder="end date"
                                            bg="gray.50"
                                            rounded="lg"
                                            size="md"
                                            border="1px solid"
                                            borderColor="gray.300"
                                            focusBorderColor="gray.100"
                                            _placeholder={{ color: "gray" }}
                                        />
                                    </Flex>

                                </Flex>
                                <Button
                                    w="full"
                                    bg="orange.300"
                                    _hover={{ bg: "orange.400" }}
                                    transition="all 0.5s ease-in-out"
                                    shadow="2xl"
                                    py="4"
                                    fontWeight="semibold"
                                    color="white"
                                    rounded="lg"
                                    // onClick={() => handleSubmit(ab.type, promoCode, ab.id, ab.price)}
                                    onClick={() => {
                                        setSelectedAbonnement(ab);
                                        onOpen();
                                    }}

                                >
                                    S'abonner
                                </Button>
                            </Flex>
                        </Box>

                    ))}


                </ModalContent>
                <AlertDialog
                    size={'lg'}
                    isOpen={isOpen}
                    onClose={onClose}
                    leastDestructiveRef={cancelRef}
                >
                    <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                                Confirmer l'abonnement {promoCode}
                            </AlertDialogHeader>

                            <AlertDialogBody>
                                êtes-vous sûr de vouloir attribuer l'abonnement *{selectedAbonnement?.name}* à ce client ?
                            </AlertDialogBody>

                            <AlertDialogFooter>
                                <Button ref={cancelRef} onClick={onClose}>
                                    Annuler
                                </Button>
                                <Button
                                    colorScheme="blue"
                                    onClick={() => {
                                        handleSubmit(selectedAbonnement.type, selectedAbonnement.id, selectedAbonnement.price);
                                        onClose();
                                    }}
                                    ml={3}
                                >
                                    Confirmer
                                </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            </Modal>

            {/* <Modal
                // initialFocusRef={initialRef}
                // finalFocusRef={finalRef}
                isOpen={isChangeStripeCIdOpen}
                onClose={onCloseStripeCIdModal}
            >
                <ModalOverlay />
                {selectedClient?.stripe_customer_id ?


                    <ModalContent>
                        <ModalHeader>Modifier L'identifiant stripe d'utilisateur</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>

                            <FormControl >
                                <FormLabel>Identifiant stripe</FormLabel>
                                <Input defaultValue={selectedClient?.stripe_customer_id} onChange={(e) => setStripeCId(e.target.value)} placeholder='cus_xxxxxxxxxxxxxx' />
                            </FormControl>
                        </ModalBody>

                        <ModalFooter>
                            <Button onClick={() => handleStripeCustomerIdChange(userId)} colorScheme='blue' mr={3}>
                                Modifier
                            </Button>
                            <Button onClick={onCloseStripeCIdModal}>Annuler</Button>
                        </ModalFooter>
                    </ModalContent>
                    :
                    <ModalContent>
                        <ModalHeader>Ajouter L'identifiant stripe d'utilisateur</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>

                            <FormControl >
                                <FormLabel>Identifiant stripe</FormLabel>
                                <Input value={stripeCId} onChange={(e) => setStripeCId(e.target.value)} placeholder='cus_xxxxxxxxxxxxxx' />
                            </FormControl>
                        </ModalBody>

                        <ModalFooter>
                            <Button isLoading={addingCodeProgress} isDisabled={addingCodeProgress || !stripeCId} onClick={() => handleStripeCustomerIdChange(userId)} colorScheme='blue' mr={3}>
                                Ajouter
                            </Button>
                            <Button onClick={onCloseStripeCIdModal}>Annuler</Button>
                        </ModalFooter>
                    </ModalContent>
                }

            </Modal> */}
            {/* <Modal
                size={"full"}
                isOpen={isPreviewOpen}
                onClose={() => {
                    onClosePreview();
                }}
            >
                <ModalOverlay />
                <ModalContent
                    w="auto"
                    // maxW="400px"
                    bg="transparent"
                    boxShadow="none"
                    display="flex"
                    flexDir={{ base: "column", md: "row" }}
                    gap={5}
                    justifyContent="center"
                    alignItems="center"
                >
                    {abonnements.map((ab, key) => (
                        <Box
                            key={1}
                            minW={"350px"}
                            p="6"
                            bg="white"
                            textAlign="center"
                            rounded="2xl"
                            shadow="xl"
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            overflowY="auto" // Scroll if content exceeds max height
                            height="100%" // Ensure the Box stretches to the full height of its container
                        >
                            <Box>
                                <Box>
                                    <Heading size="lg" mb="2" color="black" fontWeight="semibold">
                                        {ab?.name}
                                    </Heading>
                                    <Text>{ab?.description}</Text>
                                    <Text pt="2" letterSpacing="wide">
                                        <Text as="span" color="orange.400" verticalAlign="top">
                                            €{" "}
                                        </Text>
                                        <Text as="span" fontSize="2xl" fontWeight="semibold" color="orange.400">
                                            {ab?.price}
                                        </Text>
                                        <Text as="span" fontWeight="medium" color="orange.400">
                                            {" "}
                                            / {ab?.type === "ANNUEL" ? "Année" : "Mois"}
                                        </Text>
                                    </Text>
                                </Box>

                                <Divider mt="4" borderColor="gray.300" />
                                <Flex justify={"center"} pt="5" flexDirection="column" align="center">
                                    {ab?.features?.map((feature, index) => (
                                        <Text
                                            textAlign="center"
                                            key={index}
                                            fontSize="md"
                                            fontWeight="semibold"
                                            color="black"
                                            pt="4"
                                        >
                                            {feature}
                                        </Text>
                                    ))}
                                </Flex>
                            </Box>
                            <Flex flexDirection="column" mt="8" gap="3" flexGrow={1}>
                                <Input
                                    onChange={(e) => setPromoCode(e.target.value)}
                                    type="text"
                                    placeholder="Code promo"
                                    bg="gray.50"
                                    rounded="lg"
                                    size="md"
                                    border="1px solid"
                                    borderColor="gray.300"
                                    focusBorderColor="gray.100"
                                    _placeholder={{ color: "gray" }}
                                />
                                <Button
                                    w="full"
                                    bg="orange.300"
                                    _hover={{ bg: "orange.400" }}
                                    transition="all 0.5s ease-in-out"
                                    shadow="2xl"
                                    py="4"
                                    fontWeight="semibold"
                                    color="white"
                                    rounded="lg"
                                    // onClick={() => handleSubmit(ab.type, promoCode, ab.id, ab.price)}
                                    onClick={() => {
                                        setSelectedAbonnement(ab);
                                        onOpen();
                                    }}

                                >
                                    S'abonner
                                </Button>
                            </Flex>
                        </Box>

                    ))}


                </ModalContent>
                <AlertDialog
                size={'lg'}
                    isOpen={isOpen}
                    onClose={onClose}
                    leastDestructiveRef={cancelRef}
                >
                    <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                                Confirmer l'abonnement {promoCode}
                            </AlertDialogHeader>

                            <AlertDialogBody>
                            êtes-vous sûr de vouloir attribuer l'abonnement *{selectedAbonnement?.name}* à ce client ?
                            </AlertDialogBody>

                            <AlertDialogFooter>
                                <Button ref={cancelRef} onClick={onClose}>
                                    Annuler
                                </Button>
                                <Button
                                    colorScheme="blue"
                                    onClick={() => {
                                        handleSubmit(selectedAbonnement.type, promoCode, selectedAbonnement.id, selectedAbonnement.price);
                                        onClose();
                                    }}
                                    ml={3}
                                >
                                    Confirmer
                                </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            </Modal> */}
        </Box>

    )
}

export default GestClients
